import { useMemo, useState } from 'react';

import { Stack, Button, Modal, Box, Typography } from '@mui/material';

import { ActionItem, createActionItem } from '@urbanmix-tech/shared-js';

import { ErrorBoundary } from '@sentry/react';
import { CustomActionGenerationModalContent } from '../CustomActionGenerationModalContent';
import { CompletedAccordion } from './CompletedAccordion';
import { ActionGroupList } from '../../BuildingTabs/DashboardActionGroupList';
import { useUIContext, useLoading } from '@/shared/context/UIContextProvider';
import WorkflowsProvider from '@/components/BuildingWorkflows/WorkflowsProvider';
import { useAlert } from '@/contexts/Alert/AlertContext';

const today = new Date();

export type TodoTabContentProps = {
  projectId: string | undefined;
  buildingId: string | undefined;
  unitId: string | undefined;
  actions: ActionItem[];
  onClickActionItem(actionItem: ActionItem): void;
  onSaveAction(actionItem: ActionItem, payload?: unknown): void;
};

export function TodoTabContent({
  projectId,
  buildingId,
  unitId,
  actions,
  onClickActionItem,
  onSaveAction,
}: TodoTabContentProps) {
  const [openedModal, setOpenedModal] = useState(false);

  const { createLoading } = useLoading();

  const handleCloseModal = () => {
    setOpenedModal(false);
  };

  const handleClickAddCustomAction = () => {
    setOpenedModal(true);
  };

  const handleGenerateNewActionItem = (
    title: string,
    description: string,
    dueDate: Date
  ) => {
    if (projectId && buildingId && unitId) {
      const actionItem = createActionItem({
        projectId,
        buildingId: +buildingId,
        unitId,
        title,
        description,
        severtity: 'regular',
        dueDate,
        startDate: today,
        reminderFrequency: 1,
        status: 'active',
        category: 'general',
        action_type: {
          inputType: 'text',
          reminder: false,
          type: 'approve',
        },
      });
      onSaveAction(actionItem, {});
    }
  };

  const loader = useMemo(() => createLoading(), []);

  const { showAlert } = useAlert();

  return (
    <Stack gap="16px" className="h-full w-[640px]">
      <Stack
        direction="row"
        alignItems="center"
        gap="16px"
        className="z-20 w-[900px]"
      >
        <Button
          variant="outlined"
          size="small"
          className="!border-white px-8 py-0 !text-white"
          onClick={handleClickAddCustomAction}
        >
          + Add Custom Task
        </Button>
      </Stack>

      <Stack className="h-full overflow-auto pr-[8px]" gap="16px">
        <ErrorBoundary fallback={<p>Error loading tasks</p>}>
          <ActionGroupList
            actionItems={actions.filter((action) => action.status === 'active')}
            onClickActionItem={onClickActionItem}
          />
        </ErrorBoundary>
        {/* <CompletedAccordion
          actions={actions.filter((action) => action.status !== 'active')}
          onClickActionItem={onClickActionItem}
        /> */}
        {projectId ? (
          <Stack gap="16px">
            <Typography>Actions and Workflows</Typography>
            <hr />
            <WorkflowsProvider
              projectId={projectId}
              unitId={unitId}
              onWorkflowStart={(workflow) => {
                loader.startLoading({ title: 'Running ' + workflow.name });
              }}
              onWorkflowEnd={(workflow, response) => {
                loader.stopLoading();

                if (response.objects) {
                  console.log('have objects', response.objects);
                  const msgs = response.objects.map((obj) => {
                    console.log('object', obj);
                    if (obj.type === 'task' && obj.id) {
                      // onClickActionItem(obj.id);
                      console.log('found task', obj.id);
                      // actionItemId = obj.id;
                      // here we want the task to actually open
                    }
                  });
                  
                }
                if (response.message) {
                  showAlert(response.message, 'success');
                }
              }}
            />
          </Stack>
        ) : null}
      </Stack>

      <Modal open={!!openedModal} onClose={handleCloseModal}>
        <Box
          component="div"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[10px] border border-stone-200 border-opacity-[0.15] shadow outline-none"
        >
          <CustomActionGenerationModalContent
            onGenerate={handleGenerateNewActionItem}
            onClose={handleCloseModal}
          />
        </Box>
      </Modal>
    </Stack>
  );
}
